module.exports = __webpack_public_path__ + "media/audio30.be000c39.mp3";